import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
    query: '',

    isLoading: false,


    yearRange: {
        min: '',
        max: '',
        _min: 0,
        _max: 0
    },

    // because facets are replaced between searches, we need to keep their states in a different object
    activeFacets: [],
    facets: [],
    results: [],

    showPagination: false,
    currentPage: 0
};

export {
    actions,
    getters,
    mutations,
    state
}